import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { chatBubble, chatMessage } from '../styles';
import { LibreChatMessage } from '../../../../api/services/chat-service';

type Props = {
  message: LibreChatMessage;
};

export const ChatMessage: React.FC<Props> = ({ message }: Props) => {
  const isUser = message.role === 'user';

  return (
    <Box sx={chatMessage(isUser)}>
      <Paper elevation={0} sx={chatBubble(isUser)}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mb: 0.5 }}>
          {isUser ? 'You' : 'Assistant'}
        </Typography>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
          {message.content}
        </Typography>
      </Paper>
    </Box>
  );
};
